import { z } from 'zod';
import { GatewayManifestAdapterAssignmentSchema } from './gateway-manifest-adapter-assignment.js';
/**
 * Generic S3 gateway config manifest (EFEM, location, future gateway types).
 * Cloud push services validate type-specific reload policies before upload.
 */
export const GatewayConfigManifestComponentSchema = z.object({
    key: z.string(),
    url: z.string().url(),
    localPath: z.string(),
    reloadPolicy: z.string(),
    changed: z.boolean(),
    /** When omitted, edge skips hash verification (e.g. synthetic manifests). */
    contentSha256: z.string().optional(),
    /** Set on the efem-adapter manifest entry when reloadPolicy is adapter-swap (old install to stop). */
    previousEfemAdapterKey: z.string().nullable().optional(),
});
export const GatewayConfigManifestSchema = z.object({
    configVersion: z.string(),
    tenantId: z.string().uuid(),
    gatewaySerialNumber: z.string().min(1),
    gatewayType: z.enum(['efem', 'location']).optional(),
    pushedAt: z.string().datetime(),
    presignedUrlExpiresAt: z.string().datetime().optional(),
    pushedBy: z
        .object({
        userId: z.string(),
        email: z.string().email().or(z.literal('')),
    })
        .optional(),
    components: z.record(z.string(), GatewayConfigManifestComponentSchema),
    /** Commissioned OEM adapter for this gateway (from Dynamo assignment at push time). */
    adapterAssignment: GatewayManifestAdapterAssignmentSchema.optional(),
});
export const ApplyGatewayConfigCommandSchema = z.object({
    serialNumber: z.string().min(1),
    configVersion: z.string().min(1),
    siteId: z.string().uuid().optional(),
    /** Optional presigned manifest URL (cloud MQTT). Edge prefers manifestKey + TES S3 fetch. */
    manifestUrl: z.string().url().optional(),
    /** S3 object key for manifest.json (edge TES fetch). */
    manifestKey: z.string().optional(),
});
export const GatewayConfigComponentApplyResultSchema = z.object({
    path: z.string(),
    changed: z.boolean(),
    reload: z.string(),
});
export const GatewayConfigApplyResultSchema = z.object({
    status: z.enum(['applied', 'failed']),
    configVersion: z.string(),
    failedPhase: z.enum(['download', 'commit', 'reload']).optional(),
    components: z.record(z.string(), GatewayConfigComponentApplyResultSchema).optional(),
    error: z.string().optional(),
    metadata: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=gateway-config-manifest-schemas.js.map